export default __webpack_public_path__ + "static/media/maintenance.ac127c1a.jpg";